import type { RootState } from 'APP/Store/CreateStore'

export const selectAppSessionState = (state: RootState) => state.appSession
